import { useState, useEffect, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, useParams, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/myTrack/ProtectedRoute';
import MyTrackApp from './components/myTrack/MyTrack';
import PaymentPage from './components/myTrack/docNo';
import Home from './components/myTrack/home';
import CarPage from './components/myTrack/carpage';
import Transactions from './components/myTrack/transactions';
import TransactionPosting from './components/myTrack/transactions/TransactionPosting';
import PartsTransactionPosting from './components/myTrack/parts/PartsTransactionPosting';
import SerialLookup from './components/myTrack/parts/SerialLookup';
import WeeklySummaryPage from './components/myTrack/WeeklySummaryPage';
import AllTransactions from './components/myTrack/AllTransactions';
import Notifications from './components/myTrack/notifications';
import Header from './components/myTrack/header';
import CarTransactions from './components/myTrack/CarTransactions';
import MyCarsApp from './components/myTrack/MyCars';
import MyDriversApp from './components/myTrack/MyDrivers';
import DriverDetails from './components/myTrack/drivers/DriverDetails';
import DriverFormPage from './components/myTrack/drivers/DriverFormPage';
import BlacklistedDrivers from './components/myTrack/drivers/BlacklistedDrivers';
import AllocationsPage from './components/myTrack/drivers/allocations/AllocationsPage';
import OwnersPage from './components/myTrack/owners';
import OwnersStatus from './components/myTrack/owners/ownersStatus';
import OwnerAnalysisCodes from './components/myTrack/owners/OwnerAnalysisCodes';
import CarParts from './components/myTrack/parts/CarPartsPage';
import Settings from './components/myTrack/settings';
import InspectionCheckItems from './components/myTrack/settings/InspectionCheckItems';
import InternalInspections from './components/myTrack/inspections/InternalInspections';
import InspectionCreate from './components/myTrack/inspections/InspectionCreate';
import InspectionConduct from './components/myTrack/inspections/InspectionConduct';
import GovernmentInspections from './components/myTrack/inspections/GovernmentInspections';
import Login from './components/myTrack/login';
import Signup from './components/myTrack/signup';
import ResetPassword from './components/myTrack/ResetPassword';
import ForgotPassword from './components/myTrack/ForgotPassword';
import PasswordResetLink from './components/myTrack/PasswordResetLink';
import CarInsurances from './components/myTrack/insurance/CarInsurancesExpiry';
import FleetInsurance from './components/myTrack/insurance/FleetInsurance';
import { ThemeProvider } from "@material-tailwind/react";
import { AuthProvider } from './components/myTrack/AuthContext';
import { useAuth } from './components/myTrack/AuthContext';
import InstallPrompt from './components/common/InstallPrompt';
import { PayersProvider } from './context/PayersContext';
import { JobCardStagesProvider } from './context/JobCardStagesContext';
import { SidebarProvider, useSidebar } from './context/SidebarContext';
import SideBarNav from './components/common/SideBarNav';
import InsuranceTypes from './components/myTrack/insurance/InsuranceTypes';
import InsuranceCompany from './components/myTrack/insurance/InsuranceCompany';
import CarStatus from './components/myTrack/cars/CarStatus';
import CarDrivers from './components/myTrack/CarDrivers';
import TransactionDetails from './components/myTrack/car/pay/TransactionDetails';
import Messages from './components/myTrack/Messages';
import MessagesIndex from './components/myTrack/messages/MessagesIndex';
import MessageRules from './components/myTrack/messages/MessageRules';
import TransMessages from './components/myTrack/TransMessages';
import LogViewer from './components/myTrack/LogViewer';
import PaymentTypes from './components/myTrack/PaymentTypes';
import OwnerPaymentTypes from './components/myTrack/OwnerPaymentTypes';
import QueueMonitor from './components/common/QueueMonitor';
import WeeklyReports from './components/myTrack/reports/WeeklyReports';
import ZeroInvoiceReport from './components/myTrack/reports/ZeroInvoiceReport';
import ReportsHub from './components/myTrack/reports/ReportsHub';
import StockValuationReport from './components/myTrack/reports/StockValuationReport';
import VehicleDrilldownReport from './components/myTrack/reports/VehicleDrilldownReport';
import TransactionDrilldownReport from './components/myTrack/reports/TransactionDrilldownReport';
import ExpenseDrilldownReport from './components/myTrack/reports/ExpenseDrilldownReport';
import StockItemDrilldownReport from './components/myTrack/reports/StockItemDrilldownReport';
import OwnerDrilldownReport from './components/myTrack/reports/OwnerDrilldownReport';
import FinanceAccountDrilldownReport from './components/myTrack/reports/FinanceAccountDrilldownReport';
import BulkPosting from './components/myTrack/BulkPosting';
import PartManufacturers from './components/myTrack/parts/PartManufacturers';
import PartCategories from './components/myTrack/parts/PartCategories';
import PartStatuses from './components/myTrack/parts/PartStatuses';
import PartSuppliers from './components/myTrack/parts/PartSuppliers';
import UnitsOfMeasure from './components/myTrack/parts/UnitsOfMeasure';
import PartModels from './components/myTrack/parts/PartModels';
import PartTypes from './components/myTrack/parts/PartTypes';
import PostDriverTransaction from './components/myTrack/drivers/transactions/PostDriverTransaction';
import BulkPostDriverTransactions from './components/myTrack/drivers/transactions/BulkPostDriverTransactions';
import DriverTransactionsList from './components/myTrack/drivers/transactions/DriverTransactionsList';
import DriverTransactionDetails from './components/myTrack/drivers/transactions/DriverTransactionDetails';
import ExpenseManagement from './components/myTrack/expenses/ExpenseManagement';
import ExpenseCategories from './components/myTrack/expenses/ExpenseCategories';
import ExpenseSubcategories from './components/myTrack/expenses/ExpenseSubcategories';
import TaskDetail from './components/myTrack/tasks/TaskDetail';
import TasksPage from './components/myTrack/tasks/TasksPage';
import WorkflowList from './components/myTrack/tasks/WorkflowList';
import WorkflowDetail from './components/myTrack/tasks/WorkflowDetail';
import ExpenseReports from './components/myTrack/expenses/ExpenseReports';
import ExpenseBudgetManagement from './components/myTrack/expenses/ExpenseBudgetManagement';
import ExpenseDetailPage from './components/myTrack/expenses/ExpenseDetailPage';
import ExpenseApprovals from './components/myTrack/expenses/ExpenseApprovals';
import { EXPENSE_APPROVALS_PATH } from './components/myTrack/expenses/expenseNavigationConfig';
import CategoryAnalytics from './components/myTrack/expenses/CategoryAnalytics';
import ExpenseGLPosting from './components/myTrack/expenses/ExpenseGLPosting';
import ExpenseFormPage from './components/myTrack/expenses/ExpenseFormPage';
import JobCardsManagement from './components/myTrack/jobCards/JobCardsManagement';
import JobCardInvoicing from './components/myTrack/jobCards/JobCardInvoicing';
import JobCardGLPosting from './components/myTrack/jobCards/JobCardGLPosting';
import JobCardReconciliation from './components/myTrack/jobCards/JobCardReconciliation';
import MonthlyInvoices from './components/myTrack/owners/MonthlyInvoices';
import BulkMonthlyInvoices from './components/myTrack/owners/BulkMonthlyInvoices';
import MonthlyInvoiceReports from './components/myTrack/owners/MonthlyInvoiceReports';
import MonthlyInvoiceEditor from './components/myTrack/owners/MonthlyInvoiceEditor';
import OwnerMonthlyInvoiceGuide from './components/myTrack/owners/OwnerMonthlyInvoiceGuide';
import PublicOwnerDocumentPage from './components/myTrack/owners/PublicOwnerDocumentPage';
import PublicJobDocumentPage from './components/myTrack/jobCards/PublicJobDocumentPage';
import CashbookDashboard from './components/myTrack/cashbook/CashbookDashboard';
import CashbookNewEntry from './components/myTrack/cashbook/CashbookNewEntry';
import CashbookAccounts from './components/myTrack/cashbook/CashbookAccounts';
import CashbookAccountFormPage from './components/myTrack/cashbook/CashbookAccountFormPage';
import CashbookStatement from './components/myTrack/cashbook/CashbookStatement';
import IncomeReport from './components/myTrack/cashbook/IncomeReport';
import MpesaStatement from './components/myTrack/cashbook/MpesaStatement';
import CashbookTransactions from './components/myTrack/cashbook/CashbookTransactions';
import WeeklyRemittanceProcessor from './components/myTrack/remittance/WeeklyRemittanceProcessor';
import RemittanceSummaryReport from './components/myTrack/remittance/RemittanceSummaryReport';
import OwnerRemittanceReport from './components/myTrack/remittance/OwnerRemittanceReport';
import OwnerRemittanceDetail from './components/myTrack/remittance/OwnerRemittanceDetail';
import PaymentAllocationAudit from './components/myTrack/remittance/PaymentAllocationAudit';
import PaymentReconciliation from './components/myTrack/remittance/PaymentReconciliation';
import ArchivedRemittances from './components/myTrack/remittance/ArchivedRemittances';
import RemittanceReports from './components/myTrack/remittance/RemittanceReports';
import C2BTransactions from './components/myTrack/payments/C2BTransactions';
import WebhookLogs from './components/myTrack/payments/WebhookLogs';
import PaymentsPerCar from './components/myTrack/cars/PaymentsPerCar';
import ArchivedCars from './components/myTrack/cars/ArchivedCars';
import OwnerStatement from './components/myTrack/owners/OwnerStatement';
import OwnerCars from './components/myTrack/owners/OwnerCars';
import OwnerTimeline from './components/myTrack/owners/OwnerTimeline';
import OwnerTransactionsList from './components/myTrack/owners/OwnerTransactionsList';
import OwnerTransactionDetails from './components/myTrack/owners/OwnerTransactionDetails';
import PostOwnerTransaction from './components/myTrack/owners/PostOwnerTransaction';
import OwnerGLPosting from './components/myTrack/owners/OwnerGLPosting';
import OwnerPaymentAllocation from './components/myTrack/owners/OwnerPaymentAllocation';
import GLJournalsPage from './components/myTrack/glJournals/GLJournalsPage';
import TrialBalance from './components/myTrack/glJournals/TrialBalance';
import ProfitAndLoss from './components/myTrack/glJournals/ProfitAndLoss';

import PartsStockCard from './components/myTrack/parts/PartsStockCard';
import PartPriceHistory from './components/myTrack/parts/PartPriceHistory';
import VendorManagement from './components/myTrack/vendors/VendorManagement';
import VendorLedger from './components/myTrack/vendors/VendorLedger';
import VendorFormPage from './components/myTrack/vendors/VendorFormPage';
import VendorLedgerPage from './components/myTrack/vendors/VendorLedgerPage';
import VatRates from './components/myTrack/settings/VatRates';
import PayersManagement from './components/settings/PayersManagement';
import JobCardStagesManagement from './components/settings/JobCardStagesManagement';
import SystemWeeksPage from './components/settings/SystemWeeksPage';
import DriverStatusAdmin from './components/myTrack/drivers/DriverStatusAdmin';
import DocumentTypesAdmin from './components/myTrack/documents/DocumentTypesAdmin';
import VehicleMakesManager from './components/myTrack/VehicleMakesManager';
import VehicleModelsManager from './components/myTrack/VehicleModelsManager';
import ChargeTypesPage from './components/myTrack/jobCards/ChargeTypesPage';
import { rootUrl } from './config/config';
import { CAR_TRANSACTIONS_SUMMARY_PERMISSION } from './components/common/carTransactionPermissions';
import JobCardPage from './components/myTrack/jobCards/JobCardPage';
import EditTransaction from './pages/transactions/EditTransaction';
import RolesPage from './pages/Admin/Roles';
import PermissionsPage from './pages/Admin/Permissions';
import ChartOfAccountsManager from './components/myTrack/settings/ChartOfAccountsManager';
import EmailLogs from './components/myTrack/EmailLogs';
import ProfilePage from './pages/Profile';
import UserMentionProfile from './components/myTrack/users/UserMentionProfile';
import LoginAudit from './pages/Admin/LoginAudit';
import SqlRunner from './pages/Admin/SqlRunner';
import WeekManagement from './pages/Admin/WeekManagement';

import DeletedTransactions from './components/myTrack/DeletedTransactions';

// Driver portal
import DriverDashboard from './components/myTrack/driver/DriverDashboard';
import DriverStatement from './components/myTrack/driver/DriverStatement';
import DriverCar from './components/myTrack/driver/DriverCar';
import DriverProfile from './components/myTrack/driver/DriverProfile';

// Owner portal
import OwnerDashboard from './components/myTrack/owner/OwnerDashboard';
import OwnerTransactions from './components/myTrack/owner/OwnerTransactions';
import OwnerInvoices from './components/myTrack/owner/OwnerInvoices';
import OwnerPortalStatement from './components/myTrack/owner/OwnerStatement';
import OwnerProfile from './components/myTrack/owner/OwnerProfile';

// Lazy load UserManagement to avoid circular dependency
const UserManagement = lazy(() => import('./pages/Admin/UserManagement'));
// Wrapper components to extract route params
const OwnerStatementWrapper = () => {
  const { code } = useParams();
  const [ownerName, setOwnerName] = useState('');

  useEffect(() => {
    // Fetch owner name
    const token = localStorage.getItem('authToken') || 'default-token';
    fetch(`${rootUrl}/owners/${code}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(response => {
        if (response && response.success && response.data) {
          setOwnerName(response.data.name || '');
        }
      })
      .catch(err => console.error('Error fetching owner:', err));
  }, [code]);

  return <OwnerStatement ownerCode={code} ownerName={ownerName} />;
};

const OwnerTimelineWrapper = () => {
  const { code } = useParams();
  const [ownerName, setOwnerName] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('authToken') || 'default-token';
    fetch(`${rootUrl}/owners/${code}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(response => {
        if (response && response.success && response.data) {
          setOwnerName(response.data.name || '');
        }
      })
      .catch(err => console.error('Error fetching owner:', err));
  }, [code]);

  return <OwnerTimeline ownerCode={code} ownerName={ownerName} />;
};

const PartsStockCardWrapper = () => {
  const { part_id } = useParams();
  const [partName, setPartName] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('authToken') || 'default-token';
    fetch(`${rootUrl}/car_parts?part_id=${part_id}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => {
        if (data && data.length > 0) {
          setPartName(data[0].part_name || '');
        }
      })
      .catch(err => console.error('Error fetching part:', err));
  }, [part_id]);

  return <PartsStockCard partId={part_id} partName={partName} />;
};

const VendorLedgerWrapper = () => {
  const { id } = useParams();
  const [supplierName, setSupplierName] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('authToken') || 'default-token';
    fetch(`${rootUrl}/parts/suppliers/${id}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => {
        if (data && data.name) {
          setSupplierName(data.name || '');
        }
      })
      .catch(err => console.error('Error fetching supplier:', err));
  }, [id]);

  return <VendorLedger supplierId={parseInt(id)} supplierName={supplierName} />;
};

// Sticky banner shown when an admin is impersonating another user
const ImpersonationBanner = () => {
  const { isImpersonating, impersonatedBy, user, stopImpersonating } = useAuth();
  if (!isImpersonating) return null;
  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] bg-amber-500 text-white flex items-center justify-between px-4 py-2 shadow-lg">
      <span className="text-sm">
        🎭 Viewing as <strong>{user?.username}</strong>
        {impersonatedBy?.username && (
          <span className="opacity-80"> &mdash; impersonated by <strong>{impersonatedBy.username}</strong></span>
        )}
        . Session expires in 1 hour.
      </span>
      <button
        onClick={stopImpersonating}
        className="ml-4 flex-shrink-0 bg-white text-amber-700 font-semibold text-xs px-3 py-1 rounded-sm hover:bg-amber-50 transition"
      >
        Stop Impersonating
      </button>
    </div>
  );
};

const App = () => (
  <ThemeProvider>
    <AuthProvider>
      <SidebarProvider>
        <PayersProvider>
          <JobCardStagesProvider>
            <MainApp />
          </JobCardStagesProvider>
        </PayersProvider>
      </SidebarProvider>
    </AuthProvider>
  </ThemeProvider>
);



const MainApp = () => {

  const { isAuthenticated, isLoggedInCheck, logout, user } = useAuth();
  const isExternalUser = isAuthenticated && user?.actor_type && user.actor_type !== 'staff';
  const { isSidebarOpen, toggleSidebar, isCollapsed, setIsCollapsed } = useSidebar();




  return (
    <>



      {isLoggedInCheck &&
        <Router>
          <ImpersonationBanner />
          <InstallPrompt />
          <div className='h-screen grid grid-rows-[auto_1fr]'>
            {isAuthenticated && !isExternalUser && (
              <Header
                toggleSidebar={toggleSidebar}
                isSidebarOpen={isSidebarOpen}
              />
            )}

            <div className={`flex overflow-hidden h-full relative`}>
              {isAuthenticated && !isExternalUser && (
                <div
                  className={`h-full sidebar flex-col bg-transparent transition-all duration-300 ${isSidebarOpen
                    ? (isCollapsed ? 'w-12 md:w-14' : 'w-52 lg:w-56')
                    : 'w-0 -translate-x-full'
                    } ease-in-out z-40 flex-shrink-0 overflow-hidden`}
                >
                  <SideBarNav
                    isAuthenticated={isAuthenticated}
                    logout={logout}
                    toggleSidebar={toggleSidebar}
                    isSidebarOpen={isSidebarOpen}
                    isCollapsed={isCollapsed}
                    setIsCollapsed={setIsCollapsed}
                  />
                </div>
              )}

              <div
                className={`flex-1 min-w-0 ${!isAuthenticated ? '' : 'p-0'} h-full overflow-y-auto overflow-x-hidden transition-all duration-300 ${isAuthenticated && isSidebarOpen
                  ? (isCollapsed ? 'ml-0 md:ml-0' : 'ml-0 md:ml-0')
                  : 'ml-0'
                  }`}
              >
                <div className="flex min-w-0">


                  <div className="flex-1 min-w-0 bg-brand-gradient overflow-x-hidden">
                    {/* Main Content */}
                    <div
                      className={`w-full min-w-0 transition-all duration-300 ${isAuthenticated && !isExternalUser ? 'pt-14' : ''}`}
                    >
                      <Routes>
                        <Route path="/" element={<ProtectedRoute element={<Home />} allowedActors={['staff']} />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/signup" element={<Signup />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/password-reset" element={<PasswordResetLink />} />
                        <Route path="/reset-password" element={<ProtectedRoute element={<ResetPassword />} />} />
                        <Route path="/profile" element={<ProtectedRoute element={<ProfilePage />} />} />
                        <Route path="/users/:username" element={<ProtectedRoute element={<UserMentionProfile />} />} />
                        <Route path="/cars/status" element={<ProtectedRoute element={<CarStatus />} />} />
                        <Route path="/allocations" element={<ProtectedRoute element={<AllocationsPage />} />} />
                        <Route path="/cars/:plate_no" element={<ProtectedRoute element={<CarTransactions />} />} />
                        <Route path="/cars/drivers/:plate_no" element={<ProtectedRoute element={<CarDrivers />} />} />
                        <Route path="/cars/:plate_no/pay/:type/:doc_no" element={<ProtectedRoute element={<TransactionDetails />} />} />
                        <Route path="/transactions/:plate_no/pay/:type/:doc_no" element={<ProtectedRoute element={<PaymentPage />} />} />
                        <Route path="/mytrack" element={<ProtectedRoute element={<MyTrackApp />} />} />
                        <Route path="/cars" element={<ProtectedRoute element={<MyCarsApp />} />} />
                        <Route path="/cars/payments" element={<ProtectedRoute element={<PaymentsPerCar />} />} />
                        <Route path="/cars/archived" element={<ProtectedRoute element={<ArchivedCars />} />} />
                        <Route path="/drivers" element={<ProtectedRoute element={<MyDriversApp />} />} />
                        <Route path="/drivers/new" element={<ProtectedRoute element={<DriverFormPage />} />} />
                        <Route path="/drivers/blacklisted" element={<ProtectedRoute element={<BlacklistedDrivers />} />} />
                        <Route path="/drivers/:id" element={<ProtectedRoute element={<DriverDetails />} />} />
                        <Route path="/drivers/:driverId/edit" element={<ProtectedRoute element={<DriverFormPage />} />} />
                        <Route path="/drivers/transactions" element={<ProtectedRoute element={<DriverTransactionsList />} />} />
                        <Route path="/drivers/transactions/post" element={<ProtectedRoute element={<PostDriverTransaction />} />} />
                        <Route path="/drivers/transactions/bulk" element={<ProtectedRoute element={<BulkPostDriverTransactions />} />} />
                        <Route path="/drivers/transactions/:type/:doc_no" element={<ProtectedRoute element={<DriverTransactionDetails />} />} />
                        <Route path="/report" element={<ProtectedRoute element={<CarPage />} />} />
                        <Route path="/reports" element={<ProtectedRoute element={<ReportsHub />} permissionKey="reports.view" denyMessage="You need the reports permission to view the reports hub." />} />
                        <Route path="/reports/drilldowns/vehicle/:id" element={<ProtectedRoute element={<VehicleDrilldownReport />} permissionKey="reports.drilldown.vehicle.view" denyMessage="You need the vehicle drilldown permission to open this report." />} />
                        <Route path="/reports/drilldowns/transaction/:id" element={<ProtectedRoute element={<TransactionDrilldownReport />} permissionKey="reports.drilldown.transaction.view" denyMessage="You need the transaction drilldown permission to open this report." />} />
                        <Route path="/reports/drilldowns/expense/:id" element={<ProtectedRoute element={<ExpenseDrilldownReport />} permissionKey="reports.drilldown.expense.view" denyMessage="You need the expense drilldown permission to open this report." />} />
                        <Route path="/reports/drilldowns/stock-item/:id" element={<ProtectedRoute element={<StockItemDrilldownReport />} permissionKey="reports.drilldown.stock_item.view" denyMessage="You need the stock drilldown permission to open this report." />} />
                        <Route path="/reports/drilldowns/owner/:id" element={<ProtectedRoute element={<OwnerDrilldownReport />} permissionKey="reports.drilldown.owner.view" denyMessage="You need the owner drilldown permission to open this report." />} />
                        <Route path="/reports/drilldowns/finance-account/:id" element={<ProtectedRoute element={<FinanceAccountDrilldownReport />} permissionKey="reports.drilldown.finance_account.view" denyMessage="You need the finance account drilldown permission to open this report." />} />
                        <Route path="/notifications" element={<ProtectedRoute element={<Notifications />} />} />
                        <Route path="/transactions" element={<ProtectedRoute element={<Transactions />} />} />
                        <Route path="/transactions/post" element={<ProtectedRoute element={<TransactionPosting />} />} />
                        <Route path="/transactions/bulk" element={<ProtectedRoute element={<BulkPosting />} />} />
                        <Route
                            path="/cars/transactions/summary"
                            element={
                                <ProtectedRoute
                                    element={<WeeklySummaryPage />}
                                    permissionKey={CAR_TRANSACTIONS_SUMMARY_PERMISSION}
                                    denyMessage="You need the car transaction executive view permission to open the summary page."
                                />
                            }
                        />
                        <Route path="/parts/transactions/post" element={<ProtectedRoute element={<PartsTransactionPosting />} />} />
                        <Route path="/parts/serials" element={<ProtectedRoute element={<SerialLookup />} />} />
                        <Route path="/cosmosettings" element={<ProtectedRoute element={<Settings />} />} />
                        <Route path="/gl-master-data" element={<ProtectedRoute element={<OwnerAnalysisCodes />} />} />
                        <Route path="/owner-analysis-codes" element={<Navigate to="/gl-master-data" replace />} />
                        <Route path="/chart-of-accounts" element={<ProtectedRoute element={<ChartOfAccountsManager />} />} />
                        <Route path="/gl-journals" element={<ProtectedRoute element={<GLJournalsPage />} />} />
                        <Route path="/trial-balance" element={<ProtectedRoute element={<TrialBalance />} />} />
                        <Route path="/profit-and-loss" element={<ProtectedRoute element={<ProfitAndLoss />} />} />
                        <Route path="/settings/inspections" element={<ProtectedRoute element={<InspectionCheckItems />} />} />
                        <Route path="/settings/vat-rates" element={<ProtectedRoute element={<VatRates />} />} />
                        <Route path="/settings/payers" element={<ProtectedRoute element={<PayersManagement />} />} />
                        <Route path="/settings/job-card-stages" element={<ProtectedRoute element={<JobCardStagesManagement />} />} />
                        <Route path="/settings/system-weeks" element={<ProtectedRoute element={<SystemWeeksPage />} />} />
                        <Route path="/settings/driver-statuses" element={<ProtectedRoute element={<DriverStatusAdmin />} />} />
                        <Route path="/settings/document-types" element={<ProtectedRoute element={<DocumentTypesAdmin />} />} />
                        <Route path="/inspections/internal" element={<ProtectedRoute element={<InternalInspections />} />} />
                        <Route path="/inspections/internal/new" element={<ProtectedRoute element={<InspectionCreate />} />} />
                        <Route path="/inspections/internal/:id/conduct" element={<ProtectedRoute element={<InspectionConduct />} />} />
                        <Route path="/inspections/government" element={<ProtectedRoute element={<GovernmentInspections />} />} />
                        <Route path="/owners" element={<ProtectedRoute element={<OwnersPage />} />} />
                        <Route path="/owners/transactions" element={<ProtectedRoute element={<OwnerTransactionsList />} />} />
                        <Route path="/owners/transactions/:ownerCode/:transId" element={<ProtectedRoute element={<OwnerTransactionDetails />} />} />
                        <Route path="/owners/transactions/post" element={<ProtectedRoute element={<PostOwnerTransaction />} />} />
                        <Route path="/owners/gl-posting" element={<ProtectedRoute element={<OwnerGLPosting />} />} />
                        <Route path="/owners/payments" element={<ProtectedRoute element={<OwnerPaymentAllocation />} />} />
                        <Route path="/owner/status" element={<ProtectedRoute element={<OwnersStatus />} />} />
                        <Route path="/car_parts" element={<ProtectedRoute element={<CarParts />} />} />
                        <Route path="/all_transactions" element={<ProtectedRoute element={<AllTransactions />} />} />
                        <Route path="/cars/deleted-transactions" element={<ProtectedRoute element={<DeletedTransactions />} />} />
                        <Route path="/transactions/edit/:id" element={<ProtectedRoute element={<EditTransaction />} />} />
                        <Route path="/messages" element={<ProtectedRoute element={<Messages rootUrl={rootUrl} token={localStorage.getItem('authToken') || 'default-token'} />} />} />
                        <Route path="/messages/dashboard" element={<ProtectedRoute element={<MessagesIndex rootUrl={rootUrl} token={localStorage.getItem('authToken') || 'default-token'} />} />} />
                        <Route path="/messages/rules" element={<ProtectedRoute element={<MessageRules rootUrl={rootUrl} token={localStorage.getItem('authToken') || 'default-token'} />} />} />
                        <Route path="/messages/trans" element={<ProtectedRoute element={<TransMessages />} />} />
                        <Route path="/logs" element={<ProtectedRoute element={<LogViewer />} />} />
                        <Route path="/email-logs" element={<ProtectedRoute element={<EmailLogs />} />} />
                        <Route path="/admin/login-audit" element={<ProtectedRoute element={<LoginAudit />} />} />
                        <Route path="/admin/sql-runner" element={<ProtectedRoute element={<SqlRunner />} />} />
                        <Route path="/admin/week-management" element={<ProtectedRoute element={<WeekManagement />} />} />
                        <Route path="/cars/insurances/:plate_no" element={<ProtectedRoute element={<CarInsurances />} />} />
                        <Route path="/insurance/fleet" element={<ProtectedRoute element={<FleetInsurance />} />} />
                        <Route path="/insurance/types" element={<ProtectedRoute element={<InsuranceTypes />} />} />
                        <Route path="/insurance/companies" element={<ProtectedRoute element={<InsuranceCompany />} />} />
                        <Route path="/pay_trans/type" element={<ProtectedRoute element={<PaymentTypes />} />} />
                        <Route path="/settings/owner-payment-types" element={<ProtectedRoute element={<OwnerPaymentTypes />} />} />
                        <Route path="/reports/weekly" element={<ProtectedRoute element={<WeeklyReports />} />} />
                        <Route path="/reports/zero-invoices" element={<ProtectedRoute element={<ZeroInvoiceReport />} />} />
                        <Route path="/reports/stock-valuation" element={<ProtectedRoute element={<StockValuationReport />} permissionKey="reports.stock.view" denyMessage="You need the stock report permission to view stock valuation." />} />
                        <Route path="/queue/monitor" element={<ProtectedRoute element={<QueueMonitor />} />} />
                        <Route path="/parts/manufacturers" element={<ProtectedRoute element={<PartManufacturers />} />} />
                        <Route path="/parts/categories" element={<ProtectedRoute element={<PartCategories />} />} />
                        <Route path="/parts/statuses" element={<ProtectedRoute element={<PartStatuses />} />} />
                        <Route path="/parts/suppliers" element={<ProtectedRoute element={<PartSuppliers />} />} />
                        <Route path="/parts/units" element={<ProtectedRoute element={<UnitsOfMeasure />} />} />
                        <Route path="/parts/types" element={<ProtectedRoute element={<PartTypes />} />} />
                        <Route path="/part_model_type" element={<ProtectedRoute element={<PartModels />} />} />
                        <Route path="/expenses" element={<ProtectedRoute element={<ExpenseManagement />} permissionKey="expenses.view" denyMessage="You need the expense view permission to open expense management." />} />
                        <Route path={EXPENSE_APPROVALS_PATH} element={<ProtectedRoute element={<ExpenseApprovals />} permissionKey="expenses.approve" denyMessage="You need the expense approval permission to review pending expenses." />} />
                        <Route path="/expenses/new" element={<ProtectedRoute element={<ExpenseFormPage />} permissionKey="expenses.create" denyMessage="You need the expense create permission to add a new expense." />} />
                        <Route path="/expenses/:expenseId/edit" element={<ProtectedRoute element={<ExpenseFormPage />} permissionKey="expenses.edit" denyMessage="You need the expense edit permission to update an expense." />} />
                        <Route path="/expenses/:expenseId" element={<ProtectedRoute element={<ExpenseDetailPage />} permissionKey="expenses.view" denyMessage="You need the expense view permission to open expense details." />} />
                        <Route path="/expenses/dashboard" element={<Navigate to="/expenses" replace />} />
                        <Route path="/expenses/reports" element={<ProtectedRoute element={<ExpenseReports />} permissionKey="expenses.reports.view" denyMessage="You need the expense reports permission to view expense reports." />} />
                        <Route path="/expenses/budgets" element={<ProtectedRoute element={<ExpenseBudgetManagement />} permissionKey="expenses.budgets.manage" denyMessage="You need the budget management permission to access expense budgets." />} />
                        <Route path="/expenses/analytics" element={<ProtectedRoute element={<CategoryAnalytics />} permissionKey="expenses.analytics.view" denyMessage="You need the expense analytics permission to view category analytics." />} />
                        <Route path="/expenses/categories" element={<ProtectedRoute element={<ExpenseCategories />} permissionKey="expenses.categories.manage" denyMessage="You need the expense categories permission to manage categories." />} />
                        <Route path="/expenses/subcategories" element={<ProtectedRoute element={<ExpenseSubcategories />} permissionKey="expenses.subcategories.manage" denyMessage="You need the expense subcategories permission to manage subcategories." />} />
                        <Route path="/expenses/gl-posting" element={<ProtectedRoute element={<ExpenseGLPosting />} permissionKey="expenses.gl_post" denyMessage="You need the GL posting permission to open expense GL posting." />} />
                        <Route path="/tasks" element={<ProtectedRoute element={<TasksPage />} />} />
                        <Route path="/tasks/board" element={<Navigate to="/tasks?view=board" replace />} />
                        <Route path="/tasks/:taskId" element={<ProtectedRoute element={<TaskDetail />} />} />
                        <Route path="/workflows" element={<ProtectedRoute element={<WorkflowList />} />} />
                        <Route path="/workflows/:projectId" element={<ProtectedRoute element={<WorkflowDetail />} />} />
                        <Route path="/projects" element={<Navigate to="/workflows" replace />} />
                        <Route path="/projects/:projectId" element={<ProtectedRoute element={<WorkflowDetail />} />} />
                        <Route path="/job-cards/list" element={<ProtectedRoute element={<JobCardsManagement />} />} />
                        <Route path="/job-cards-invoicing" element={<ProtectedRoute element={<JobCardInvoicing />} />} />
                        <Route path="/job-cards/reconciliation" element={<ProtectedRoute element={<JobCardReconciliation />} />} />
                        <Route path="/job-cards/gl-posting" element={<ProtectedRoute element={<JobCardGLPosting />} />} />
                        <Route path="/owners/invoices/monthly" element={<ProtectedRoute element={<MonthlyInvoices />} />} />
                        <Route path="/owners/invoices/monthly/bulk" element={<ProtectedRoute element={<BulkMonthlyInvoices />} />} />
                        <Route path="/owners/invoices/monthly/reports" element={<ProtectedRoute element={<MonthlyInvoiceReports />} />} />
                        <Route path="/owners/invoices/monthly/edit/:ownerCode/:transId" element={<ProtectedRoute element={<MonthlyInvoiceEditor />} />} />
                        <Route path="/owners/invoices/monthly/guide" element={<ProtectedRoute element={<OwnerMonthlyInvoiceGuide />} />} />
                        <Route path="/share/owner-document/:token" element={<PublicOwnerDocumentPage />} />
                        <Route path="/share/job-document/:token" element={<PublicJobDocumentPage />} />
                        <Route path="/job-cards/:jobCardId" element={<ProtectedRoute element={<JobCardPage />} />} />
                        <Route path="/cashbook" element={<ProtectedRoute element={<CashbookDashboard />} permissionKey="cashbook.dashboard.view" denyMessage="You need the cashbook dashboard permission to open the cashbook dashboard." />} />
                        <Route path="/cashbook/new" element={<ProtectedRoute element={<CashbookNewEntry />} />} />
                        <Route path="/cashbook/accounts" element={<ProtectedRoute element={<CashbookAccounts />} />} />
                        <Route path="/cashbook/accounts/new" element={<ProtectedRoute element={<CashbookAccountFormPage />} />} />
                        <Route path="/cashbook/accounts/:id/edit" element={<ProtectedRoute element={<CashbookAccountFormPage />} />} />
                        <Route path="/cashbook/statement/:accountId" element={<ProtectedRoute element={<CashbookStatement />} />} />
                        <Route path="/cashbook/report" element={<ProtectedRoute element={<IncomeReport />} />} />
                        <Route path="/cashbook/mpesa-statement/:accountId" element={<ProtectedRoute element={<MpesaStatement />} />} />
                        <Route path="/cashbook/transactions/:accountId" element={<ProtectedRoute element={<CashbookTransactions />} />} />
                        <Route path="/remittance" element={<ProtectedRoute element={<WeeklyRemittanceProcessor />} />} />
                        <Route path="/remittance/summary-report" element={<ProtectedRoute element={<RemittanceSummaryReport />} />} />
                        <Route path="/remittance/owner-report" element={<ProtectedRoute element={<OwnerRemittanceReport />} />} />
                        <Route path="/remittance/owner-detail/:owner_code/:week_key" element={<ProtectedRoute element={<OwnerRemittanceDetail />} />} />
                        <Route path="/remittance/batch/:batchId" element={<ProtectedRoute element={<PaymentAllocationAudit />} />} />
                        <Route path="/remittance/reconciliation" element={<ProtectedRoute element={<PaymentReconciliation />} />} />
                        <Route path="/remittance/archived" element={<ProtectedRoute element={<ArchivedRemittances />} />} />
                        <Route path="/remittance/reports" element={<ProtectedRoute element={<RemittanceReports />} />} />
                        <Route path="/payments/c2b-transactions" element={<ProtectedRoute element={<C2BTransactions />} />} />
                        <Route path="/payments/webhook-logs" element={<ProtectedRoute element={<WebhookLogs />} />} />
                        <Route path="/owners/statements/:code" element={<ProtectedRoute element={<OwnerStatementWrapper />} />} />
                        <Route path="/owners/cars/:code" element={<ProtectedRoute element={<OwnerCars />} />} />
                        <Route path="/owners/timeline/:code" element={<ProtectedRoute element={<OwnerTimelineWrapper />} />} />
                        <Route path="/car_parts/:part_id/price-history" element={<ProtectedRoute element={<PartPriceHistory />} />} />
                        <Route path="/parts/stock-cards/:part_id" element={<ProtectedRoute element={<PartsStockCardWrapper />} />} />
                        <Route path="/vendors" element={<ProtectedRoute element={<VendorManagement />} />} />
                        <Route path="/vendors/new" element={<ProtectedRoute element={<VendorFormPage />} />} />
                        <Route path="/vendors/:id/edit" element={<ProtectedRoute element={<VendorFormPage />} />} />
                        <Route path="/vendors/:id/ledger" element={<ProtectedRoute element={<VendorLedgerPage />} />} />
                        <Route path="/vendors/ledgers/:id" element={<ProtectedRoute element={<VendorLedgerWrapper />} />} />
                        <Route path="/vehicles/makes" element={<ProtectedRoute element={<VehicleMakesManager />} />} />
                        <Route path="/vehicles/models" element={<ProtectedRoute element={<VehicleModelsManager />} />} />
                        <Route path="/job-cards/charge-types" element={<ProtectedRoute element={<ChargeTypesPage />} />} />
                        <Route path="/admin/roles" element={<ProtectedRoute element={<RolesPage />} />} />
                        <Route path="/admin/permissions" element={<ProtectedRoute element={<PermissionsPage />} />} />
                        <Route path="/admin/users" element={<ProtectedRoute element={<Suspense fallback={<div className="p-8 text-center">Loading...</div>}><UserManagement /></Suspense>} />} />

                        {/* Driver portal */}
                        <Route path="/driver/dashboard" element={<ProtectedRoute element={<DriverDashboard />} allowedActors={['driver']} />} />
                        <Route path="/driver/statement" element={<ProtectedRoute element={<DriverStatement />} allowedActors={['driver']} />} />
                        <Route path="/driver/car" element={<ProtectedRoute element={<DriverCar />} allowedActors={['driver']} />} />
                        <Route path="/driver/profile" element={<ProtectedRoute element={<DriverProfile />} allowedActors={['driver']} />} />

                        {/* Owner portal */}
                        <Route path="/owner/dashboard" element={<ProtectedRoute element={<OwnerDashboard />} allowedActors={['owner']} />} />
                        <Route path="/owner/transactions" element={<ProtectedRoute element={<OwnerTransactions />} allowedActors={['owner']} />} />
                        <Route path="/owner/invoices" element={<ProtectedRoute element={<OwnerInvoices />} allowedActors={['owner']} />} />
                        <Route path="/owner/statement" element={<ProtectedRoute element={<OwnerPortalStatement />} allowedActors={['owner']} />} />
                        <Route path="/owner/profile" element={<ProtectedRoute element={<OwnerProfile />} allowedActors={['owner']} />} />
                      </Routes>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </Router>
      }</>
  );
};


export default App;
